import { render, staticRenderFns } from "./CustomVSSidebarGroup.vue?vue&type=template&id=a69a8908&"
import script from "./CustomVSSidebarGroup.vue?vue&type=script&lang=js&"
export * from "./CustomVSSidebarGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomVSSidebarGroup.vue"
export default component.exports